<script lang="ts">
  import {getContext, onDestroy} from 'svelte';

  import * as Store from '@/store';

  import Dialog from '@/components/dialog/Dialog.svelte';
  import VideoPlayer from '@/components/video-snapshot/VideoPlayer.svelte';

  // export let isVidImgDialogOpen = true;
  import {triggerOnSeek} from '@components';
  import editorInstance from '@/lib/editor/editor';
  import {httpClient} from '@/utils/http-client';
  // export let videoFilesLength = 0;

  export let isCreateImageOpen = false;
  export let createDraft = (isSelected: number) => {};
  // export let selectedVideos:Video[] = [];
  let isSelected = 0;

  function closeDialog() {
    isCreateImageOpen = false;
  }
</script>

<Dialog bind:isDialogOpen={isCreateImageOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-center justify-center">
    <form
      on:submit|preventDefault={() => {}}
      class="max-w-[1100px ] pointer-events-auto mx-4 h-auto w-3/5 min-w-[280px] rounded-2xl border border-gray-300 bg-white shadow-lg dark:border-zinc-600 dark:bg-zinc-700"
    >
      <div class="flex flex-row p-6 text-black dark:text-zinc-200">
        <div class="flex w-full flex-col">
          <div class="flex items-start justify-between pb-4">
            <h1 class="w-full text-center text-3xl font-bold">What would you like to create?</h1>
            <button on:click={closeDialog} class="ml-4 rounded-lg px-2 hover:bg-zinc-100 dark:hover:bg-zinc-600">
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <hr class="border-t border-t-gray-300 dark:border-zinc-600" />
      <div class="grid p-6">
        <div class="mt-7 flex flex-wrap items-center justify-center gap-4">
          <div
            class="flex w-[275px] min-w-[240px] shrink grow cursor-pointer flex-col self-stretch overflow-hidden rounded-lg border-[3px] border-solid px-7 pb-5 pt-10 max-md:px-5 {!isSelected
              ? 'border-rose-500'
              : 'border-zinc-400 hover:border-primary-200'}"
            on:click={() => {
              isSelected = 0;
            }}
            on:keypress={() => {
              isSelected = 0;
            }}
          >
            <img
              loading="lazy"
              src="https://storage.googleapis.com/sermonshots-homepage/v2/images/quotes.png"
              alt=""
              class="w-full object-contain"
            />
            <div class="mt-7 flex flex-col">
              <h2 class="text-xl font-medium text-neutral-800">Quotes & Verses</h2>
              <p class="text-md mt-3 leading-5 text-zinc-700">
                Create a social media image with a speaker’s photo and an engaging quote from the sermon.
              </p>
            </div>
          </div>

          <div
            class="flex w-[275px] min-w-[240px] shrink grow cursor-pointer flex-col self-stretch overflow-hidden rounded-lg border-[3px] border-solid px-7 pb-5 pt-10 max-md:px-5 {isSelected
              ? 'border-rose-500'
              : 'border-zinc-400 hover:border-primary-200'}"
            on:click={() => {
              isSelected = 1;
            }}
            on:keypress={() => {
              isSelected = 1;
            }}
          >
            <img
              loading="lazy"
              src="https://storage.googleapis.com/sermonshots-homepage/v2/images/thumbnail.png"
              alt=""
              class="w-full object-contain"
            />
            <div class="mt-7 flex flex-col">
              <h2 class="text-xl font-medium text-neutral-800">Thumbnail</h2>
              <p class="text-md mt-3 leading-5 text-zinc-700">
                Design an eye-catching thumbnail for YouTube videos or sermon clips.
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr class="border-t border-t-gray-300 dark:border-zinc-600" />
      <div class="my-4 flex justify-center gap-2.5 self-center whitespace-nowrap text-sm font-medium">
        <button
          on:click={closeDialog}
          class="min-h-[40px] w-[111px] gap-2 self-stretch rounded-lg border border-solid border-zinc-400 px-3 py-2 py-2.5 text-zinc-500 hover:bg-zinc-200"
        >
          Cancel
        </button>
        <button
          on:click={() => createDraft(isSelected)}
          class="min-h-[40px] gap-1.5 self-stretch rounded-md bg-primary px-4 py-2.5 py-3 text-white hover:bg-primary-600"
        >
          Continue
        </button>
      </div>
    </form>
  </div>
</Dialog>
